// SPEC-119 FR-5 / D3: an account terminated for abuse answers the login
// step that proves ownership (correct password, valid code, successful
// social sign-in) with a distinct error code. Every login surface shows the
// same sentence with a way to reach support, and nothing else: no retry,
// no code offer, no generic error.
export const RESTRICTED_ACCOUNT_CODE = 'account_restricted'
export const SUPPORT_EMAIL = 'support@stanwinstonschool.com'
export const RESTRICTED_ACCOUNT_MESSAGE = 'Your account has been restricted.'
export const RESTRICTED_ACCOUNT_CONTACT = 'Contact'

// Backend contract: HTTP 400 with the flat OTP-error shape
// {"detail": "<sentence>", "error_code": "account_restricted"} from
// /auth/login/, /auth/otp/verify/ and the social sign-in endpoints, only
// after proof of ownership. The failure payload fetchHelper resolves with is
// { status, value } where value is that body (snake_case, not decamelized).
export const isRestrictedAccount = (payload) => {
  const body = payload?.value !== undefined ? payload.value : payload
  return Boolean(body) && body.error_code === RESTRICTED_ACCOUNT_CODE
}
